<template>
    <section>
        <SfeTabs default-tab="all">
          <SfeTabList>
            <SfeTabTrigger value="all">
              All
              <span class="fs-12 font-italic text-muted" v-if="searchQuery">
                ({{ (actions?.length || 0) + (isSuperAdmin ? applicantDetails?.nbHits || 0 : 0) + (jobData?.length || 0) }})
              </span>
            </SfeTabTrigger>

            <SfeTabTrigger value="actions">
              Actions
              <span class="fs-12 font-italic text-muted" v-if="searchQuery">({{ actions?.length || 0 }})</span>
            </SfeTabTrigger>

            <SfeTabTrigger value="applicants" v-if="isSuperAdmin">
              Applicants
              <span class="fs-12 font-italic text-muted" v-if="searchQuery">({{ applicantDetails?.nbHits || 0 }})</span>
            </SfeTabTrigger>

            <SfeTabTrigger value="jobs">
              Jobs
              <span class="fs-12 font-italic text-muted" v-if="searchQuery">({{ jobData?.length || 0 }})</span>
            </SfeTabTrigger>
          </SfeTabList>


            <SfeTabContent value="all">
                <div v-if="noDataAvailable">
                    <div class="px-3 py-3 text-muted text-center">
                        Search not found!
                    </div>
                </div>
                <!-- For all -->
                <div v-else>
                    <!-- For actions -->
                    <div v-if="actions.length">
                        <div class="fs-14 text-muted mx-3 mb-0 mt-3">ACTIONS</div>
                        <div  role="button" v-for="(item, index) in actions" :key="index" class="my-1 dropdown-item">
                            <div class="d-flex align-items-center my-2 ml-1 mr-5" @click.prevent="$emit('action:taken', $helpers.getObjectProperty(item, 'item', ''))">
                                <div class="bg-light-grey-1 rounded-circle p-1">
                                <i class="material-icons text-primary mt-1 fs-20 mx-1">{{ $helpers.getObjectProperty(item, 'item.icon', '') }}</i>
                                </div>
                                <div class="w-100">
                                <p class="mb-0 ml-2 fs-13 fw-400 text-truncate text-capitalize" v-html="markWord($helpers.getObjectProperty(item, 'item.name', ''), searchQuery)"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- For applicants-->
                    <div v-if="!applicantLoadingState && applicantDetails?.hits?.length && isSuperAdmin">
                        <div class="fs-14 text-muted mx-3 mb-0 mt-3">Applicants</div>
                        <div  role="button" v-for="(applicant, index) in applicantDetails.hits.slice(0, 3)" :key="index" class="my-1 dropdown-item">
                            <div @click.prevent="$emit('view:applicant', applicant.candidate_id)" class="d-flex align-items-center my-2 ml-1 mr-5">
                                <div class="bg-light-grey-1 rounded-circle p-1">
                                    <i class="material-icons text-primary mt-1 fs-20 mx-1">person</i>
                                </div>
                                <div class="w-100">
                                    <p class="mb-0 ml-2 fs-13 fw-400 text-truncate text-capitalize" v-html="markWord($helpers.getObjectProperty(applicant, 'first_name', '') + ' ' + $helpers.getObjectProperty(applicant, 'last_name', ''), searchQuery)"></p>
                                </div>
                            </div>
                        </div>
                        <div v-if="$helpers.getObjectProperty(applicantDetails, 'hits', []).length >= 3 && isSuperAdmin">
                            <div class="my-1 dropdown-item cursor-pointer" @click.prevent="$emit('go-to:talent-pool')">
                                <div class="d-flex align-items-center my-2 ml-1 mr-5">
                                    <div class="bg-light-grey-1 rounded-circle py-2 px-2">
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.41699 6.5C7.83121 6.5 8.16699 6.16421 8.16699 5.75C8.16699 5.33579 7.83121 5 7.41699 5C7.00278 5 6.66699 5.33579 6.66699 5.75C6.66699 6.16421 7.00278 6.5 7.41699 6.5ZM8.16699 8.75C8.16699 9.16421 7.83121 9.5 7.41699 9.5C7.00278 9.5 6.66699 9.16421 6.66699 8.75C6.66699 8.33579 7.00278 8 7.41699 8C7.83121 8 8.16699 8.33579 8.16699 8.75ZM7.41699 12.5C7.83121 12.5 8.16699 12.1642 8.16699 11.75C8.16699 11.3358 7.83121 11 7.41699 11C7.00278 11 6.66699 11.3358 6.66699 11.75C6.66699 12.1642 7.00278 12.5 7.41699 12.5ZM11.167 5.75C11.167 6.16421 10.8312 6.5 10.417 6.5C10.0028 6.5 9.66699 6.16421 9.66699 5.75C9.66699 5.33579 10.0028 5 10.417 5C10.8312 5 11.167 5.33579 11.167 5.75ZM10.417 9.5C10.8312 9.5 11.167 9.16421 11.167 8.75C11.167 8.33579 10.8312 8 10.417 8C10.0028 8 9.66699 8.33579 9.66699 8.75C9.66699 9.16421 10.0028 9.5 10.417 9.5ZM11.167 11.75C11.167 12.1642 10.8312 12.5 10.417 12.5C10.0028 12.5 9.66699 12.1642 9.66699 11.75C9.66699 11.3358 10.0028 11 10.417 11C10.8312 11 11.167 11.3358 11.167 11.75ZM13.417 12.5C13.8312 12.5 14.167 12.1642 14.167 11.75C14.167 11.3358 13.8312 11 13.417 11C13.0028 11 12.667 11.3358 12.667 11.75C12.667 12.1642 13.0028 12.5 13.417 12.5ZM5.16699 18C4.89085 18 4.66699 17.7761 4.66699 17.5V3.5C4.66699 2.67157 5.33857 2 6.16699 2H12.167C12.9954 2 13.667 2.67157 13.667 3.5V8H15.167C15.9954 8 16.667 8.67157 16.667 9.5V17.5C16.667 17.7761 16.4431 18 16.167 18H5.16699ZM5.66699 3.5V17H7.66699V14.5C7.66699 14.2239 7.89085 14 8.16699 14H13.167C13.4431 14 13.667 14.2239 13.667 14.5V17H15.667V9.5C15.667 9.22386 15.4431 9 15.167 9H13.167C12.8909 9 12.667 8.77614 12.667 8.5V3.5C12.667 3.22386 12.4431 3 12.167 3H6.16699C5.89085 3 5.66699 3.22386 5.66699 3.5ZM12.667 15H11.167V17H12.667V15ZM10.167 15H8.66699V17H10.167V15Z" fill="#296DB3"/>
                                    </svg>
                                    </div>
                                    <div class="w-100 ml-3 d-flex flex-column justify-content-center">
                                    <div class="fs-14 fw-400 text-truncate text-capitalize">
                                        See more results for: <mark class="bg-highlight text-dark">{{ applicantDetails.query }}</mark>
                                    </div>
                                    <div class="text-muted fs-10">Talent pool &nbsp; > &nbsp; {{ applicantDetails.nbHits }} applicants results</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- For Jobs -->
                    <div v-if="!jobLoadingState && jobData.length">
                        <div class="fs-14 text-muted mx-3 mb-0 mt-3">JOBS</div>
                        <div  role="button" v-for="(item, index) in jobData" :key="index" class="my-1 dropdown-item" @click.prevent="$emit('go-to:job-appliaction', item.id)">
                        <div class="d-flex align-items-center my-2 ml-1 mr-5">
                            <div class="bg-light-grey-1 rounded-circle p-2">
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.16699 3C7.89085 3 7.66699 3.22386 7.66699 3.5V6H6.16699C4.78628 6 3.66699 7.11929 3.66699 8.5V13.5C3.66699 14.8807 4.78628 16 6.16699 16H15.167C16.5477 16 17.667 14.8807 17.667 13.5V8.5C17.667 7.11929 16.5477 6 15.167 6H13.667V3.5C13.667 3.22386 13.4431 3 13.167 3H8.16699ZM12.667 6H8.66699V4H12.667V6ZM6.16699 7H15.167C15.9954 7 16.667 7.67157 16.667 8.5V13.5C16.667 14.3284 15.9954 15 15.167 15H6.16699C5.33856 15 4.66699 14.3284 4.66699 13.5V8.5C4.66699 7.67157 5.33857 7 6.16699 7Z" fill="#296DB3"/>
                            </svg>
                            </div>
                            <div class="w-100">
                            <p class="mb-0 ml-2 fs-13 fw-400 text-truncate text-capitalize" v-html="markWord(item.title, searchQuery)"></p>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div v-if="!jobLoadingState && !jobData.length && !applicantDetails" class="px-3 py-1 text-muted">
                        Search not found!
                    </div>
                </div>
            </SfeTabContent>
            <SfeTabContent value="actions">
                <div v-if="actions.length">
                    <div class="fs-14 text-muted mx-3 mb-0 mt-3">ACTIONS</div>
                    <div  role="button" v-for="(item, index) in actions" :key="index" class="my-1 dropdown-item">
                        <div class="d-flex align-items-center my-2 ml-1 mr-5" @click.prevent="$emit('action:taken', $helpers.getObjectProperty(item, 'item', ''))">
                            <div class="bg-light-grey-1 rounded-circle p-1">
                            <i class="material-icons text-primary mt-1 fs-20 mx-1">{{ $helpers.getObjectProperty(item, 'item.icon', '') }}</i>
                            </div>
                            <div class="w-100">
                            <p class="mb-0 ml-2 fs-13 fw-400 text-truncate" v-html="markWord($helpers.getObjectProperty(item, 'item.name', ''), searchQuery)"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p class="px-3 py-3 text-muted text-center">
                        Search not found!
                    </p>
                </div>
            </SfeTabContent>
            <SfeTabContent value="applicants">
                <div v-if="applicantLoadingState">
                    <HorizontalListLoader/>
                </div>
                <div v-else>
                    <div v-if="!applicantLoadingState && applicantDetails?.hits?.length">
                        <div class="fs-14 text-muted mx-3 mb-0 mt-3">Applicants</div>
                        <div  role="button" v-for="(applicant, index) in applicantDetails.hits.slice(0, 3)" :key="index" class="my-1 dropdown-item">
                            <div @click.prevent="$emit('view:applicant', applicant.candidate_id)" class="d-flex align-items-center my-2 ml-1 mr-5">
                                <div class="bg-light-grey-1 rounded-circle p-1">
                                    <i class="material-icons text-primary mt-1 fs-20 mx-1">person</i>
                                </div>
                                <div class="w-100">
                                    <p class="mb-0 ml-2 fs-13 fw-400 text-truncate text-capitalize" v-html="markWord($helpers.getObjectProperty(applicant, 'first_name', '') + ' ' + $helpers.getObjectProperty(applicant, 'last_name', ''), searchQuery)"></p>
                                </div>
                            </div>
                        </div>
                        <div v-if="$helpers.getObjectProperty(applicantDetails, 'hits', []).length >= 3">
                            <div class="my-1 dropdown-item cursor-pointer" @click.prevent="$emit('go-to:talent-pool')">
                                <div class="d-flex align-items-center my-2 ml-1 mr-5">
                                    <div class="bg-light-grey-1 rounded-circle py-2 px-2">
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.41699 6.5C7.83121 6.5 8.16699 6.16421 8.16699 5.75C8.16699 5.33579 7.83121 5 7.41699 5C7.00278 5 6.66699 5.33579 6.66699 5.75C6.66699 6.16421 7.00278 6.5 7.41699 6.5ZM8.16699 8.75C8.16699 9.16421 7.83121 9.5 7.41699 9.5C7.00278 9.5 6.66699 9.16421 6.66699 8.75C6.66699 8.33579 7.00278 8 7.41699 8C7.83121 8 8.16699 8.33579 8.16699 8.75ZM7.41699 12.5C7.83121 12.5 8.16699 12.1642 8.16699 11.75C8.16699 11.3358 7.83121 11 7.41699 11C7.00278 11 6.66699 11.3358 6.66699 11.75C6.66699 12.1642 7.00278 12.5 7.41699 12.5ZM11.167 5.75C11.167 6.16421 10.8312 6.5 10.417 6.5C10.0028 6.5 9.66699 6.16421 9.66699 5.75C9.66699 5.33579 10.0028 5 10.417 5C10.8312 5 11.167 5.33579 11.167 5.75ZM10.417 9.5C10.8312 9.5 11.167 9.16421 11.167 8.75C11.167 8.33579 10.8312 8 10.417 8C10.0028 8 9.66699 8.33579 9.66699 8.75C9.66699 9.16421 10.0028 9.5 10.417 9.5ZM11.167 11.75C11.167 12.1642 10.8312 12.5 10.417 12.5C10.0028 12.5 9.66699 12.1642 9.66699 11.75C9.66699 11.3358 10.0028 11 10.417 11C10.8312 11 11.167 11.3358 11.167 11.75ZM13.417 12.5C13.8312 12.5 14.167 12.1642 14.167 11.75C14.167 11.3358 13.8312 11 13.417 11C13.0028 11 12.667 11.3358 12.667 11.75C12.667 12.1642 13.0028 12.5 13.417 12.5ZM5.16699 18C4.89085 18 4.66699 17.7761 4.66699 17.5V3.5C4.66699 2.67157 5.33857 2 6.16699 2H12.167C12.9954 2 13.667 2.67157 13.667 3.5V8H15.167C15.9954 8 16.667 8.67157 16.667 9.5V17.5C16.667 17.7761 16.4431 18 16.167 18H5.16699ZM5.66699 3.5V17H7.66699V14.5C7.66699 14.2239 7.89085 14 8.16699 14H13.167C13.4431 14 13.667 14.2239 13.667 14.5V17H15.667V9.5C15.667 9.22386 15.4431 9 15.167 9H13.167C12.8909 9 12.667 8.77614 12.667 8.5V3.5C12.667 3.22386 12.4431 3 12.167 3H6.16699C5.89085 3 5.66699 3.22386 5.66699 3.5ZM12.667 15H11.167V17H12.667V15ZM10.167 15H8.66699V17H10.167V15Z" fill="#296DB3"/>
                                    </svg>
                                    </div>
                                    <div class="w-100 ml-3 d-flex flex-column justify-content-center">
                                    <div class="fs-14 fw-400 text-truncate text-capitalize">
                                        See more results for: <mark class="bg-highlight text-dark">{{ applicantDetails.query }}</mark>
                                    </div>
                                    <div class="text-muted fs-10">Talent pool &nbsp; > &nbsp; {{ applicantDetails.nbHits }} applicants results</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="px-3 py-3 text-muted text-center">
                            Search not found!
                        </p>
                    </div>
                </div>
            </SfeTabContent>
            <SfeTabContent value="jobs">
                <div v-if="jobLoadingState">
                    <HorizontalListLoader/>
                </div>
                <div v-else>
                    <div v-if="!jobLoadingState && jobData.length">
                        <div class="fs-14 text-muted mx-3 mb-0 mt-3">JOBS</div>
                        <div  role="button" v-for="(item, index) in jobData" :key="index" class="my-1 dropdown-item" @click.prevent="$emit('go-to:job-appliaction', item.id)">
                        <div class="d-flex align-items-center my-2 ml-1 mr-5">
                            <div class="bg-light-grey-1 rounded-circle p-2">
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.16699 3C7.89085 3 7.66699 3.22386 7.66699 3.5V6H6.16699C4.78628 6 3.66699 7.11929 3.66699 8.5V13.5C3.66699 14.8807 4.78628 16 6.16699 16H15.167C16.5477 16 17.667 14.8807 17.667 13.5V8.5C17.667 7.11929 16.5477 6 15.167 6H13.667V3.5C13.667 3.22386 13.4431 3 13.167 3H8.16699ZM12.667 6H8.66699V4H12.667V6ZM6.16699 7H15.167C15.9954 7 16.667 7.67157 16.667 8.5V13.5C16.667 14.3284 15.9954 15 15.167 15H6.16699C5.33856 15 4.66699 14.3284 4.66699 13.5V8.5C4.66699 7.67157 5.33857 7 6.16699 7Z" fill="#296DB3"/>
                            </svg>
                            </div>
                            <div class="w-100">
                            <p class="mb-0 ml-2 fs-13 fw-400 text-truncate" v-html="markWord(item.title, searchQuery)"></p>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div v-if="!jobLoadingState && !jobData.length" class="px-3 py-3 text-muted text-center">
                        Search not found!
                    </div>
                </div>
            </SfeTabContent>
        </SfeTabs>
    </section>
</template>

<script>
    import HorizontalListLoader from '../admin/jobs/job-management/applicant-tracking-system/includes/loaders/utility/HorizontalList'
    export default {
        name: 'GlobalSearch',
        components: {
            HorizontalListLoader
        },
        data() {
            return {
                applicantDetails: {}
            }
        },
        props: {
            actions: {
                type: Array,
                default: () => ([])
            },
            jobData: {
                type: Array,
                default: () => ([])
            },
            applicantData: {
                type: Object,
                default: () => ({})
            },
            searchQuery: {
                type: String,
                default: ''
            },
            applicantLoadingState: {
                type: Boolean,
                default: false
            },
            jobLoadingState: {
                type: Boolean,
                default: false
            },
            isSuperAdmin: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            noDataAvailable() {
                return !this.applicantDetails?.hits?.length && !this.jobData?.length && !this.actions?.length
            }
        },
        methods: {
            markWord(text, wordToMark){
                return text?.replace(new RegExp(wordToMark, 'gi'), '<mark class="bg-highlight text-dark">' + wordToMark + '</mark>')

            }
        },
        watch: {
            applicantData(newVal) {
                if (!this.isSuperAdmin) {
                    this.applicantDetails = {}
                } else {
                    this.applicantDetails = newVal
                }
            }
        }
    }
</script>
